<div class="dialog-main__container">
  <div class="dialog-header__container">
    <h3 class="dialog-header__title">Agreement information</h3>
  </div>

  <!---------- main content ---------->

  <div class="dialog-content__container">
    <form [formGroup]="agreementForm">
      <div class="row">
        <div class="col-6">
          <div class="form__item mb-3">
            <label class="label-input col-sm-5">Agreement no</label>
            <div class="col-sm-3">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="agreementNo"
              />
            </div>
          </div>
          <div class="form__item mb-3">
            <label class="label-input col-sm-5">NDA</label>
            <div class="col-sm-3 agreement__dropdown">
              <app-dropdown
                formControlName="nda"
                [items]="ndaDropdown"
              ></app-dropdown>
            </div>
          </div>
          <div class="form__item mb-3">
            <label class="label-input col-sm-5">Comment</label>
            <div class="col-sm-3">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="comment"
              />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form__item mb-3">
            <label class="label-input col-sm-5">Agreement start date</label>
            <div class="col-sm-3">
              <app-datepicker
                [iconLeft]="true"
                formControlName="agreementStartDate"
                [staticPropery]="true"
              ></app-datepicker>
            </div>
          </div>
          <div class="form__item mb-3">
            <label class="label-input col-sm-5">Agreement end date</label>
            <div class="col-sm-3">
              <app-datepicker
                [iconLeft]="true"
                formControlName="agreementEndDate"
                [staticPropery]="true"
              ></app-datepicker>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!--  save/cancel buttons -->
  <div class="row justify-content-end dialog-button__container pt-3">
    <div class="col-auto p-0">
      <button class="button button__save add-margin" (click)="save()">
        Save
      </button>
      <button class="button button__cancel" (click)="close()">Cancel</button>
    </div>
  </div>

  <img
    class="interview__trash icon"
    src="assets/icons/svg/trash/ion_trash-bin.svg"
    alt="trash"
    *ngIf="!isCreate"
    (click)="deleteAgreement()"
  />
</div>
